import { ComponentDocs } from "components/docs";
import { ExternalProps } from "constants/external";

const FormCheckboxTree = () => (
  <ComponentDocs
    name="<Form.CheckboxTree/>"
    entry="CheckboxTree"
    propsEntry="CheckboxTreeProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiTreeView}
  >
    {/* TODO standard checkbox tree */}
  </ComponentDocs>
);

export default FormCheckboxTree;
